import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'CHCĘ PAKIET PLASTYKA GOTOWA',
  href = '#oferta',
  className = ''
}: CtaButtonProps) {
  const isExternal = /^https?:\/\//.test(href);
  return <a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className={`group inline-flex items-center justify-center gap-2 rounded-full bg-coral px-8 py-3.5 text-[11px] font-bold uppercase tracking-[0.14em] text-white shadow-[0_10px_24px_-12px_rgba(233,84,58,0.9)] transition-colors duration-150 ease-out hover:bg-coral-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-coral-dark focus-visible:ring-offset-2 focus-visible:ring-offset-cream ${className}`} data-id="element-205" data-mp="20t97n8g9kt1w">
      {label}
      <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-206" data-mp="185dc472fl76p" />
    </a>;
}